exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.app[data-v-5ef48958] {\n  font-size: 16px;\n}\n.app[data-v-5ef48958] * {\n    font-family: \"Helvetica Neue\", Helvetica, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen-Sans, Ubuntu, Cantarell, sans-serif;\n    box-sizing: border-box;\n}\n.app[data-v-5ef48958] img {\n    max-width: 100%;\n}\n.app[data-v-5ef48958] a {\n    cursor: pointer;\n    color: #1E2D3E;\n    text-decoration: none;\n}\n.app[data-v-5ef48958] input {\n    font-family: \"Helvetica Neue\", Helvetica, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen-Sans, Ubuntu, Cantarell, sans-serif !important;\n}\n", ""]);

// exports
